const language = [
    // English
    {
        'key' : "en",
        'currentLanguage': 0,
        'title' : "Elephant tent",
        'aboutus':"About us",
        "findmore" : 'Fing more',
        "clients" : "With over 10 years’ experience with companies from all kind of business we can proudly say we have lots of satisfied and happy clients.",
        "among" : "Among them are:",
        'description': `We work with heart and a lot of thought, when designing the teambuilding for the needs of your business. By using skills gained at the CIPD London (with Trainings Needs Analysis specialty) our team is offering the optimal design for each client.
We always search for an out of the box solution for your soft skills empowering needs. We are proud to say that we always suggest a solution that will entertain and be effective at the same time.
With over 10 years’ experience with companies from all kind of business we can proudly say we have lots of satisfied and happy clients.`,
        'among' :   `Among them are:`,
        'contacts' : "Contacts",
        'contacts1': "Contacts and team",
        'adress':"Elefant Tent Ltd. ",
        'adress1' : "Sofia, Bulgaria",
        'phone' : "phone",
        'email' : "Email",
        'facebook': "Facebook",
        'home' : "Home",
        'teambuildings' : "Teambuildings",
        'teamstext' : `You can look at small part of our active offers, which we have already done for groups of 10 to 500 people.
But we will expect your inquiry and requirements, so that we could fit an event for you.
`,
        'members' : "Who we are:",
        'ivan' : "Ivan Radenkov",
        'sofia' : "Sofia Stamenkova",
        'maria' : "Maria Kirilova",
        'petio' : "Petio Krivoshiev",
        'ivan1' : `Завършил Института по Човешки Ресурси – Великобритания (CIPD – UK). Притежател на MBA от Софийския Университет. 12 години стаж на водещи позиции в  Човешките ресурси в компании като Ernst and Young, Paysafe, International Human Resources, Елефант Тент, Matrix . Професионалист в дизайна на тимбилдинги; Training Needs Analysis и т. на т.
Завършил курса на Иван Терзиев по Кино и ТВ Режисура 2004 година НАТФИЗ.
`,
        'sofia1' : `Над 6 години опит в Outward Bound, Adventure net и 8 години със Палатката на Слона. Сертифициран инструктор по международни програми за трейнъри:
-	 (LTTC3488): международно обучение на Outward Bound инструктори
-	Сноуборд инструктор и безопасност в планината- Клас “А” с английски и руски език
-	Основен въжен курс – теория и практика, Долекарска помощ – теория и учебна симулация, Ориентиране и навигация – теория и практика. Ролеви игри, активности за разчупване на ледовете, сплотяване на колектива. Провеждане на анализ за извеждане на наученото след активностите. Подход според възрастовата група на участниците.
-	Active youth – Creative Adulthood – Румъния
-	Курс по лавинна безопасност (N 01/10 01 2010)
-	Удостоверение за Обучителна програма „Опит в група чрез психодрама, социометрия и групова терапия”
-	Международно обучение по програма “Youth in Action” – „NO LIMITS – Training for Youth Workers Working with Young People with Physical Disabilities
`,
      'maria1' : `Магистър по Спортна Анимация, НСА. Бакалавър по Организационно Поведение и култура.  През 14 годишният си стаж Мария е работила като аниматор, фасилитатор, организатор и дизайнер на тренинги и тимбилдинги за КонсулТим, Интернешънъл Хюмън Рисорсиз и ЕлефантТент.
Профила на Мария включва специални умения по организационно развитите, личностно и групово мотивиране. Мария е професионалист по изготвяне на интегрални личностни портрети, като при изготвянето на профилите засяга метаспособностите и емоционалната интелигентност.
`,
      'petio1' : `Възпитаник на НСА със специалност Треньор по Карате и учител по физкултура. Рaботи с Елефант Тент от 10 години. Правоспособност за ски учител, завършил спалеология и катерене. Занимава се със спортна анимация от 1997 до момента. От 2001 работи като спортен аниматор в ОДЗ и ЦДГ. В кариерата си е работил за различни държавни организации като главен организатор и инструктор, както и за Балкан Адвенчър в сектор Тимбилдинг и Приключенски лагери.
Професионален оператор и монтажист на филми за екстремни спортове.
`,
TeamsData : [
    {
      "id": 1,
      "title": "Camp of Entertainment and Challenges",
      "groups": "10 to 500 people.",
      "type": "adventure, leisure, creative, fun ",
      "description": `Participants are taken into the nature. They will have to build up their own camp with the provided from us tents and materials.
      Lunch, dinner and breakfast is delicious home - made food, by a kitchen caravan shiny cooks.`,
      "description1" : `The event will go through several phases:` ,
     "description2" :`- Challenges – build up a camp, start a fire, play traditional Bulgarian pipe with special trainers, play horo with the live folk band, play several games of teambuilding activity`,
     "description3" : `- Leisure – Lie in hammocks, listen to the chill out, Drum and Bass, Jazz brass, Funky DJ in the forest. Eat ice cream, popcorn, sugar cotton, adoring desserts, degustation of traditional lutenitza, degustation of wine, play and sing around the camp fires.`,
     "description4"  : ` - Sport – play badminton, volleyball, soccer one kick game and small teambuilding activities of your choice (like binocular soccer, ropes and beers or bow shooting)`,
     "description5" : ``,
     "description6" : ``,
      "timing": "5-24 hours",
      "img": "1.JPG"
    },
    {
      "id": 2,
      "title": "Pleasure Fair",
      "groups": "20 to 300 people.",
      "type": "creative, fun ",
      "description": `The Pleasure fair is a 6-7 topic fun and pleasure games with adorable rewards.
      Participants are divided to groups to go through certain funny, provocative, entertaining and creative tasks in order to get to their pleasure type reward and gain knowledge to produce it.
      They earn special money (printed for you), which they can use to buy others’items.
      The end is a pleasure fair, where all participants are trying out, checking listening, or just watching the products done by their colleagues and present theirs.`,
      "description1": `Chocolate, `,
      "description2" : ` Cocktail Bar,`,
      "description3" : ` Massage stand,`,
      "description4" : `Immage makers,`,
      "description5" : ` Raw bars,`,
     "description6" : ` Media,`,
     "description7" : "Fitness",
     "timing": "2-5 hours",
     "img": "4.JPG"
    },
    {
      "id": 3,
      "title": "Game of thrones",
      "groups": "40 to 300 people.",
      "type": "physical and strategy",
      "description": `In this day you will have the power and the strength to turn the history as you wanted it to be.
                     Stark can live and North will survive if YOU are able to beat your enemies; if YOU can maneuver your forces rightful and clever.
                     This story showed that not only strength was leading heroes to victory, but also knowledge, intelligence and treat…
                     But gaining honor and fame is always based on bravery and honesty in warriors. You decide how to play this out, you decide who to be.
                     There are plenty of Houses you can choose from, but also we urge you to create your own House and Family. You can play in Unions and you can break them if you decide.
                     All of this is ok by the rules of life. No one is insured to survive; this is an age of glory and betrayal;
                     age that can lead you to dominance in the Western Lands or to a total oblivion behind the Wall.`,
                     "description1": `The first task of the group is to make up a name and make their flag, slogan and logo with certain materials
                     Each state receives a certain arsenal battles (game types) through which they can invade and conquer neighboring territories.
                         `,
    "description2": `The first task of the group is to make up a name and make their flag, slogan and logo with certain materials
                       Each state receives a certain arsenal battles (game types) through which they can invade and conquer neighboring territories.
                       `,
     "description3" : `If you win 4 fights, you conquer a territory and take their flag. Defeated country can attack other countries and settle in newly conquered territories, but after 4 failures, it goes behind the WALL, from where they can also attack. They can return at the map if they win 4 times.
                       The goal is to have the largest number of sites.
                       `,
     "description4" : `List of types of battles:`,
      "description5" : "   1. Ropes and arrows.",
      "description6" :"2. Fruit race",
      "description7" : "3. Monster battle",
      "description8": " 4. Puzzle battle",
      "description9" : "5. Samuel battle of the blinds",
      "description10" :"6. National Battle",
      "description11" : "7. Water battle",
      "description12" : "8. Ropes adventure",
       "description13" : `Additional tasks for pacifists. They will be called historians - chroniclers and film and comment on interesting thing happening.
                         There will be two teams that will have a camera, tripod and microphone. You have to make a report, historical documentary and action movie of the war.
                         Or they will shoot your season of Game of thrones. The categories of material will be fighting for the top prize for Journalism,
                         Documentary and the GAME OF THRONES series and will be broadcasted at the dinner as sweet memories of the war years.`,
      "description6" : ``,
      "timing": "2-5 hours",
    "img": "23.JPG"
    },
    {
      "id": 4,
      "title": "Crazy Games",
      "groups": "10 to 200 people.",
      "type": "physical and strategy ",
      "description": "Includes a list of crazy, entertaining but creative games,",
      "description1": `1.	Binocular Soccer`,
      "description2":  `2.	Blind Graffiti sprays`,
       "description3": `3.	Bow Shooting`,
       "description4":  `4.	Beers on the ropes`,
       "description5": `5.	Sheep can speak`,
       "description6": `6.	“Three Big Balls” soccer`,
     "timing": "1-3 hours",
       "img": "29.JPG"
   },
    {
      "id": 5,
      "title": "Film challenge ",
      "groups": "10 to 200 people",
      "type": "creative and art ",
      "description": "The participants will be divided to teams that have to create movie on a topic, involving the corporation and few obligatory words or genres that we will challenge them with. Participants will receive  cameras, short training in movie making and acting and our HOW TO booklet. There are certain stages to go trough:",
      "description1": `1. Brainstorming`,
      "description2":  `2.	Script writing`,
       "description3": `3.	Shooting`,
       "description4":  `4.	Montage (by professional facilitator or together with the director)`,
       "description5": `5.	Oscars night `,
       "description6": ``,
     "timing": "1-3 hours",
     "img": "106.jpg"
   },
    {
      "id": 6,
      "title": "Communication center",
      "groups": "12 to 60 people",
      "type": "creative and art ",
      "description": "Participants need to find a way to communicate and understand each other, regardless of the conditions. The games are very strong to show and emphasize how the right communication in the office is important. Participants will play the creative and art games in or outdoors of:",
      "description1": `1.	Play without words`,
      "description2":  `2.	Intonation vs. Sense`,
       "description3": `3.	Automatical surrealistic interview`,
       "description4":  ``,
       "description5": ``,
       "description6": ``,
     "timing": "0.30 to 2 hours",
     "img": "108.jpg"
   },
   {
     "id": 7,
     "title": "Your company Olympic games",
     "groups": "60 to 500 people",
     "type": "sports and betting",
     "description": `Olympic games is a sport teambuilding event that goes with team games in various sports and fun disciplines.
     Participants play in teams against each other (departments, teams or friends ...).
     Viewers (who are participants in other disciplines) have the right to bet on their favorites with tokens money.
     Bets and payouts (1 to 1) are made before and after the match. Money tokens are specially designed and printed for the client and have pictures of colleagues or bosses of you choose.
      With them you can buy alcohol, ice cream, treats, cakes, golf lessons, horse riding etc..`,
     "description1": ``,
     "description2":  ``,
      "description3": ``,
      "description4":  ``,
      "description5": ``,
      "description6": ``,
    "timing": "5 to 12 hours",
    "img": "7.JPG"
  },
  {
    "id": 8,
    "title": "Get out alive withOUT Bear Grills",
    "groups": "10 to 100 people",
    "type": "adventure, quest",
    "description": `Using map and a compass, the participants will be involved in a Quest which will take them through entertaining and curious stops.
    Includes lots of funny elements, like “Shoot the most incredible picture/pose”`,
    "description1": ``,
    "description2":  ``,
     "description3": ``,
     "description4":  ``,
     "description5": ``,
     "description6": ``,
   "timing": "1 to 3 hours",
   "img": "26.JPG"
 },
 {
   "id": 9,
   "title": "Adventure and exreme type ",
   "groups": "",
   "type": "Adventure",
   "description": `- Scenario Paintball ear`,
   "description1": `- Rafting adventure`,
   "description2":  `- Cave adventure – In the search of the Holy Grail`,
    "description3": `- Cliff climbing, orientation, bikes `,
    "description4":  `- Tour in the mountain with scenario `,
    "description5": `- Survivor`,
    "description6": ``,
    "timing": "",
   "img": "challange1.jpg"
},
{
  "id": 10,
  "title": "Non physical games ",
  "groups": "",
  "type": "Non physical ",
  "description": " - Lord of the Chefs/ BBQ Lord – cooking tournament",
  "description1": " - Advertising Fair",
  "description2":  " - Parties of your choice (Halloween, Christmas, Karaoke…) ",
   "description3": " - Customizing your event",
   "description4":  "",
   "description5": "",
   "description6": "",
   "timing": "",
    "img": "3.JPG"
}
]
    },
    // BG
    {
        'key': "bg",
        'currentLanguage': 1,
        'aboutus': "За нас",
        'title' :  "Палатката на слона",
        "findmore": "Разбери повече",
        "clients" : "С над 10 години опит с компании от всички браншове, можем с гордост да се похвалим само с доволни и щастливи клиенти.",
        "among": "Сред тях са:",
        'description': `Работим със сърце и много мисъл, когато изграждаме тимбилдинг формата, който трябва да отговаря специално за нуждите на вашият бизнес. Нашият специалист завършил CIPD London, със защита в Trainings Needs Analysis подготвя оптималният дизайн за всеки клиент.
Винаги търсим нестандартното решение за да усъвършенстваме екипните умения на екипа ви. С гордост можем да твърдим, че винаги имаме подход, който едновременно забавлява до сълзи, но и дава търсения резултат.
С над 10 години опит с компании от всички браншове, можем с гордост да се похвалим само с доволни и щастливи клиенти.`,
        'among' : "Част от тях са:",
        'contacts': "Контакти",
        'contacts1': "Контакти и Екип",
        'adress' : "Елефант Тент ЕООД",
        'adress1' : "София, България",
        'phone': "Телефон",
        'email' : "Email",
        'facebook': "Фейсбук",
        'home' : "Начало",
        'teambuildings' : "Тиймбилдинги",
        'teamstext' : `Можете да разгледате само малка част актуалните оригинални и новаторски тимбилдинги, които сме реализирали с групи от 10 до 500 души наведнъж.
Но ще очакваме вашите запитвания и изисквания за да предложим готов или нов продукт и за вас.
`,
        'members': "Кои сме ние:",
        'ivan' : "Иван Раденков",
        'sofia' : "София Стаменкова",
        'maria' : "Мария Кирилова",
        'petio' : "Петьо Кривошиев",
        'ivan1' : `Завършил Института по Човешки Ресурси – Великобритания (CIPD – UK). Притежател на MBA от Софийския Университет. 12 години стаж на водещи позиции в  Човешките ресурси в компании като Ernst and Young, Paysafe, International Human Resources, Елефант Тент, Matrix . Професионалист в дизайна на тимбилдинги; Training Needs Analysis и т. на т.
Завършил курса на Иван Терзиев по Кино и ТВ Режисура 2004 година НАТФИЗ.
`,
        'sofia1' : `Над 6 години опит в Outward Bound, Adventure net и 8 години със Палатката на Слона. Сертифициран инструктор по международни програми за трейнъри:
-	 (LTTC3488): международно обучение на Outward Bound инструктори
-	Сноуборд инструктор и безопасност в планината- Клас “А” с английски и руски език
-	Основен въжен курс – теория и практика, Долекарска помощ – теория и учебна симулация, Ориентиране и навигация – теория и практика. Ролеви игри, активности за разчупване на ледовете, сплотяване на колектива. Провеждане на анализ за извеждане на наученото след активностите. Подход според възрастовата група на участниците.
-	Active youth – Creative Adulthood – Румъния
-	Курс по лавинна безопасност (N 01/10 01 2010)
-	Удостоверение за Обучителна програма „Опит в група чрез психодрама, социометрия и групова терапия”
-	Международно обучение по програма “Youth in Action” – „NO LIMITS – Training for Youth Workers Working with Young People with Physical Disabilities
`,
      'maria1' : `Магистър по Спортна Анимация, НСА. Бакалавър по Организационно Поведение и култура.
      През 14 годишният си стаж Мария е работила като аниматор, фасилитатор, организатор и дизайнер на тренинги и тимбилдинги за
      КонсулТим, Интернешънъл Хюмън Рисорсиз и ЕлефантТент.
Профила на Мария включва специални умения по организационно развитите, личностно и групово мотивиране.
Мария е професионалист по изготвяне на интегрални личностни портрети,
като при изготвянето на профилите засяга метаспособностите и емоционалната интелигентност.
`,
      'petio1' : `Възпитаник на НСА със специалност Треньор по Карате и учител по физкултура. Рaботи с Елефант Тент от 10 години.
       Правоспособност за ски учител, завършил спалеология и катерене. Занимава се със спортна анимация от 1997 до момента.
       От 2001 работи като спортен аниматор в ОДЗ и ЦДГ. В кариерата си е работил за различни държавни организации
       като главен организатор и инструктор, както и за Балкан Адвенчър в сектор Тимбилдинг и Приключенски лагери.
Професионален оператор и монтажист на филми за екстремни спортове.
`,
TeamsData : [
    {
      "id": 1,
      "title": "Къмпинг Забава",
      "groups": "от 10 до 500 души.",
      "type": "приключенска, разпускаща, креативна, забавление ",
      "description":`Това е тимбилдинг сред природата. Изграждаме палатков лагер, огън, храним се от подвижна караванна гурме кухня с наливна бира и дегустации на вино. Събитието преминава през няколко фази: `,
      "description1" : `- Предизвикателство – палене на огън, свирене на гайда с преподавател, хоро с фолклорна група, тиймбилдинг активности по избор`,
      "description2": `- Разпускане – излежаване в хамаците, Слушане на специалната подборка музика от Ди Джея. Сладолед, пуканки, захарен памук, страхотни десерти, дегустаране на лютеница, дегустаране на вино и песни и танци около огнището.`,
      "description3" : `- Спорт - бадмингтон, волейбол, футбол и малък тиймбилдинг по ваш избор (като бинокълен футбол, въжена градина с бирички или стрелба с лък)`,
      "timing": "5-24 часа",
      "img": "1.JPG"
    },
    {
      "id": 2,
      "title": "Панаирът на удоволствията",
      "groups": "от 20 до 300 души.",
      "type": "креативна, забавление  ",
      "description": `Панаирът на удоволствията е тимбилдинг, в който участниците усвояват нови знания и компетенции, забавляват се и сплотяват като екипи по забавни проекти. След първоначалната фаза на обучение по създаване на продукти, уастниците по различните теми създават собствен, уникален продукт и намират най-добрият начин да го презентират на последващият панаир на удоволствията. Специалните пари, които спечелят, могат да бъдат използвани за други удоволствия. Ще подготвим специални ваучери пари, с лика на ключови фигури от ръководството или администрацията, които ще са в обръщение през вечерта.`,
      "description1": "Щанд Шоколад, ",
      "description2" : "Бар,",
      "description3" : "Масажен бар,",
      "description4" : "Имидж мейкърс,",
      "description5" : " Raw Bars,",
      "description6" : " Медия,",
      "description7" : "Фитнес щанд",
      "timing": "2-5 часа",
      "img": "4.JPG"
    },
    {
      "id": 3,
      "title": "Игра на тронове",
      "groups": "от 40 до 300 души.",
      "type": "физическа и стратегическа - изисква разгрявка и средна физическа активност  ",
      "description": `В тази игра участниците се превъплъщават в героите от популярния филм Игра на тронове. Битки за железния трон, предателства, хиляди предизвикателства, ще ви оставят без дъх. Днес вие може да промените сценария на филма, злополучната съдба на Севера...
Концепцията се базира и на настолната игра РИСК. Физическото натоварване е средно и никога не навлиза в екстремното, но всички участници разполагат със застраховки.
`,
"description1": `Участниците се разделят на случаен принцип на 8 отбора, които получват по една държава (територия) на картата (поляната).  Картата е с около 10 квадратни метра и с флаговете на участниците. Голямата част от плажа е на  фронтове, подготвени за битки.
Първата задача на групите е да си измислят име и да си направят флаг, слоган и лого с определени материали. Знаме, пактове за обявяване на война и прочие ще бъдат част от атрибутите с които ще разполагат.
`,
"description2": `Всяка държава получава определен арсенал битки (типове игри) чрез които могат да нападат и завладяват съседни територии.
Имате право да обявите 4 пъти война и да се защитавате неограничено. Ако победите в двубой, завладявате дадена територия и взимате техния флаг. Победена държава може да напада други държави и да се заселва на новозавладените територии, но след 3 неуспеха, останала без териотрия тя се преселва отвъд Вала, от където може също да напада..
`,
"description3": `Целта е в края на играта вашата държава да има най-голям брой територии.`,

"description4": `Списък на типовете битки:`,
 "description5" : " 1.	Водна война – с водни пушки помпи",
 "description6" :"2.	Бомбардиране на крепостни стени с водни бомби и артилерия. Започва с щафета водни балони и приключва със самолетен десант.",
 "description7" : "3.	Балонна война",
 "description8": "4.	Плодова надпревара",
 "description9" : "5.	Чудовищна битка (битка на принципа на камък ножица хартия, но групово-стратегически)",
 "description10" :"6.	Пъзелна битка",
 "description11" : "7.	 Самуиловска битка на слепците",
 "description12" : "8.	Народна Битка (народна топка)",
"description13": `Допълнително задание за пацифистите . Те ще се нарекат историци - хроникьори и ще заснемат и коментират интересното, което се случва. Ще бъдат два отбора и ще разполагат с камера, статив и микрофон. Трябва да направят епизод от филма в стилистиката на оригинала, но базиран на реални бойни действия на трехните колеги. Различните варианти епизоди на екипите ще се бият за голямата награда на Вестерос и ще се излъчат на вечерята като мил спомен от военните години.`,
      "timing": "2-5 часа",
      "img": "23.JPG"
    },
    {
      "id": 4,
      "title": "Лудите на стадиона",
      "groups": "от 10 до 200 души.",
      "type": "физическа и стратегическа - изисква разгрявка и средна физическа активност ",
      "description": `Игра 1 Футбол с бинокли`,
      "description1": `Игра 2 Овце в кошарата `,
      "description2": `Игра 3 Стрелба `,
      "description3" : `Игра 4 Графитени битки`,
      "description4" : `Игра 5 Въжена градина с бири`,
      "description5" : `Игра 6 Тритопкен футбол`,
      "timing": "1-3 часа",
      "img": "29.JPG"
    },
    {
      "id": 5,
      "title": "Филмово Предизвикателство",
      "groups": "от 10 до 200 души.",
      "type": "креативна",
      "description": `Създаване на дух на отборност, развиване на комуникацията и възможностите за брейнсторминг  на екипа, пресъздавайки процеса и емоцията при създаването и заснемането на филм . Филмовите съставки, като заложен задължителен елемент ще бъдат свързани с корпоративната дейност и така по един забавен начин ще изградим съпричастност към компанията. В разпределението на ролите, в изплозването на камерата, монтажа, писането на сценария има огромен заряд от положителни емоции, които участниците оценяват по достойнство. Да видиш собствената си продукция излъчена пред всички, да получиш удовлетворение за добре свършената работа е мотивираща сила която ще държи дълго служителите на върха на тяхната ангажираност. `,
      "description1": `Ще зададем теми за всеки екип, свързани с фирмата и преплетени със задължителни съставки, на чиято база да се измислят бъдещите филми. Те трябва да присъстват в сюжета на филмите. На екипите се раздава наръчника на младия кинематограф, и се връчва  камера. Нарочен консултант прилепен към всеки екип (около 10 души в екип) предава своите знания и подпомага но не извършва заснемането на филма. Екипа трябва да премине през няколко контролирани фази:`,
      "description2": `1.	Брейнстроминг – предлагане на идеи и измисляне не оригинален сценарии спрямо темите `,
      "description3" : `2.	Подготовка – разкадровка, сценични площадки, разпределение на ролите, декори, грим, реплики, подготовка на оператора и актьорите. Всички до един участват.`,
      "description4" : `3.	Реализация – снимане и игра.`,
      "description5" : `4.	Монтаж – музикална оформление, монтаж, кредити. Професионално извършване с монтажна техника от консултанта.`,
      "description6" : `5.	Вечер на Оскарите – излъчване и гледане на филмите. Гласуване за статуетките и награждаване.`,
      "timing": "2-7 часа",
      "img": "106.jpg"
    },
    {
      "id": 6,
      "title": "Комуникационен Център ",
      "groups": "от 12 до 60 души.",
      "type": "креативна  ",
      "description": `Участниците разделени в отбори,  ще трябва да се научат да комуникират на един език, независимо от планетата, от която идват. Интергалактическият Комуникационен център ще даде възможносст на участниците да открият силата на невербалната комуникация; да споделят креативното в себе си чрез артистичност и да разкрият своята индивидуалност, осъзнавайки че тя трябва да се показва и най-често помага. Много силно мотивиращи и зареждащи игри за по-нататъшно сътрудничество и съпричастност.`,
      "description1": `В детайл, Интергалактическият Комуникационен център се състои от 3 игри:  `,
      "description2": `-	Пиеса без думи`,
      "description3" : `-	Сблъсък на интонационност и смисъл`,
      "description4" : `-	Автоматично сюрреалистично интервю`,
      "description5" : ``,
      "timing": "0.30-2 часа",
      "img": "108.jpg"
    },
    {
      "id": 7,
      "title": "Олимпиада",
      "groups": "от 60 до 500 души.",
      "type": "спортна, залози",
      "description": `Ден който преминава в отборни игри по различни спортни и забавни дисциплини. Участниците по предварително заявен списък играят в отбори един срещу друг (отдели, тимове или приятели…). Зрителите (които се явяват участници в други дисциплини) имат правото да залагат за своите фаворити с предварително раздадени пари. Залозите и изплащане на печалбите  (1 към 1) се извършват на гише при любезните ни асистентнки. Банкнотите се разпечатват с ликове на избрани от вас колеги или шефове. Срещу спечелените „пари” могат да се закупят алкохол, сладолед, лакомства , торти,  голф уроци, конна езда и други глезотии.`,
      "description1": ` `,
      "description2": ``,
      "description3" : ``,
      "description4" : ``,
      "description5" : ``,
      "timing": "5-12 часа",
      "img": "7.JPG"
    },
    {
      "id": 8,
      "title": "Измъкни се жив дори и без Беар Грилс",
      "groups": "от 10 до 100 души.",
      "type": "приключенска, куест",
      "description": `С помощта на компаси, екипите се съревновават в намиране на определени точки в разбъркана последователност, където със забавни игри и загадки им се предоставя ключ за търсене на следващата точка от пътешествието. Включва множество забавни елементи като „направи най-неочакваната снимка“ и др.`,
      "description1": ` `,
      "description2": ``,
      "description3" : ``,
      "description4" : ``,
      "description5" : ``,
      "timing": "1-3 часа",
      "img": "26.JPG"
    },
    {
      "id": 9,
      "title": "Приключенски, екстремни ",
      "groups": "",
      "type": "Приключенски ",
      "description": `- Пейнтбол война със сценарий`,
      "description1": `- Рафтинг и каяк приключение – „По устието на Амазонка”`,
      "description2":  `- Пещерно приключение – Индиана Джоунс и светият Граал `,
       "description3": `- Скално катерене, планинско ориентиране, колела и др. `,
       "description4":  `- Туристически преход тип екскурзионно летуване `,
       "description5": `- Сървайвър (включва лагеруване на открито, режисирано оцеляване в дивата природа)`,
       "description6": ``,
     "timing": "",
     "img": "challange1.jpg"
   },
   {
     "id": 10,
     "title": " Игрови, нефизически ",
     "groups": "",
     "type": "Нефизически ",
     "description": " - Lord of the Chefs/ BBQ Lord – готварски турнир",
     "description1": " - Рекламен панаир (предизвиква креативното във всеки, създава се реклама на фирмата от нейните служители, помага да се припознаят хората с компанията и да се почувстват важни)",
     "description2":  " - Тематични Партита (Хелоуин, Коледа... Зелено парти, Кариоки и др.)",
      "description3": " - Вашето събитие – дизайн според нуждите",
      "description4":  "",
      "description5": "",
      "description6": "",
      "timing": "",
      "img": "3.JPG"
   }
]
}

]
export default language;



// WEBPACK FOOTER //
// ./src/components/languages.js